import React, { FC, useEffect } from 'react';
import { LegislationCodeMain } from './LegislationCodeMain';
import { CodeInfos } from './legislationCode.types';
import { rebuildUrlWithoutSource } from '../../../utils/url-utils/urlUtils';

type Props = { codeInfos: CodeInfos; dateKey: string; isCode: boolean };

export const LegislationCode: FC<Props> = ({ codeInfos, dateKey, isCode }) => {
  useEffect(() => {
    rebuildUrlWithoutSource();
  }, []);

  return (
    <LegislationCodeMain
      codeInfosInit={codeInfos}
      dateKey={dateKey}
      isCode={isCode}
    />
  );
};
